import { useOrganisationBasketContext } from "@/contexts/organisations/OrganisationBasketContext";

import BasketErrorModal from "./BasketErrorModal";

const STOCK_BUNDLE_EXPLANATION =
  "Cyrex bundle tests cannot be purchased as stock. Remove the bundle from your basket or disable Order as stock.";

const STORED_SAMPLE_EXPLANATION =
  "Cyrex stored sample retrieval cannot be used with stock orders. To continue, select Blood Serum Kit as the test option or disable Order as stock.";

export default function CyrexStoredSampleStockErrorModal() {
  const {
    hasCyrexBundleStockError,
    hasCyrexStoredSampleStockError,
    hasCyrexStockOrderConflictError,
    acknowledgedBasketCyrexStoredSampleStockErrorModal,
    setAcknowledgedBasketCyrexStoredSampleStockErrorModal
  } = useOrganisationBasketContext();

  const parts = [];
  if (hasCyrexBundleStockError) {
    parts.push(STOCK_BUNDLE_EXPLANATION);
  }
  if (hasCyrexStoredSampleStockError) {
    parts.push(STORED_SAMPLE_EXPLANATION);
  }
  const explanation = parts.join(" ");

  return (
    <BasketErrorModal
      explanation={explanation}
      show={
        hasCyrexStockOrderConflictError && !acknowledgedBasketCyrexStoredSampleStockErrorModal
      }
      onClose={() => {
        setAcknowledgedBasketCyrexStoredSampleStockErrorModal(true);
      }}
    />
  );
}
